import axiosInstance from './axiosInstance';

export const STATUS_PIPELINE = [
  'Order Placed',
  'Proof received',
  'Proof approval sent to Martin Advertising',
  'Order complete and sent to printer',
];

const STATUS_ALIASES = {
  order_received: ['order_received', 'new', 'placed', 'order_placed'],
  cr_sent: ['cr_sent', 'pending_creative'],
  proof_received: ['proof_received', 'received'],
  proof_sent_to_dealer: ['proof_sent_to_dealer', 'pending_approval'],
  approval_received_from_dealer: ['approval_received_from_dealer', 'approved'],
  order_placed_with_printer: ['order_placed_with_printer', 'building'],
  order_complete_sent_to_printer: [
    'order_complete_sent_to_printer',
    'completed',
    'delivered',
  ],
};

const DEALER_PROGRESS_STEPS = {
  order_received: 1,
  cr_sent: 1,
  proof_received: 2,
  proof_sent_to_dealer: 2,
  approval_received_from_dealer: 3,
  order_placed_with_printer: 4,
  order_complete_sent_to_printer: 4,
};

const aliasToCanonical = Object.entries(STATUS_ALIASES).reduce((acc, [canonical, aliases]) => {
  aliases.forEach((alias) => {
    acc[alias] = canonical;
  });
  return acc;
}, {});

const normalizeLabel = (label) => {
  if (label === null || label === undefined) {
    return '';
  }
  return String(label).trim().toLowerCase().replace(/[\s-]+/g, '_');
};

export const getCanonicalOrderStatusLabel = (label) => {
  const normalized = normalizeLabel(label);
  return aliasToCanonical[normalized] || normalized;
};

export const getDealerProgressStepByStatusLabel = (label) => {
  const canonicalStatus = getCanonicalOrderStatusLabel(label);
  return DEALER_PROGRESS_STEPS[canonicalStatus] || 0;
};

const normalizeStatuses = (statuses = []) => {
  return statuses
    .map((status) => {
      const value = status?.value ?? status?.id;
      const label = status?.label ?? status?.status;
      if (value === null || value === undefined || label === null || label === undefined) {
        return null;
      }
      return { value: String(value), label: String(label) };
    })
    .filter(Boolean);
};

let cachedStatuses = null;
let pendingRequest = null;

export const fetchOrderStatuses = async () => {
  if (cachedStatuses) {
    return cachedStatuses;
  }
  if (pendingRequest) {
    return pendingRequest;
  }

  pendingRequest = axiosInstance
    .get('/getStatuses')
    .then((response) => {
      const statuses = normalizeStatuses(response.data?.statuses || []);
      cachedStatuses = statuses;
      pendingRequest = null;
      return statuses;
    })
    .catch((error) => {
      pendingRequest = null;
      throw error;
    });

  return pendingRequest;
};

export const getStatusIdByLabel = (statuses, label) => {
  const canonicalTarget = getCanonicalOrderStatusLabel(label);
  if (!canonicalTarget) {
    return null;
  }

  const aliases = STATUS_ALIASES[canonicalTarget] || [canonicalTarget];
  const match = (statuses || []).find(
    (status) => aliases.includes(normalizeLabel(status.label))
  );
  return match?.value ?? null;
};

export const getStatusLabelById = (statuses, statusId) => {
  if (statusId === null || statusId === undefined) {
    return null;
  }
  const id = String(statusId);
  const match = (statuses || []).find((status) => String(status.value) === id);
  return match?.label ?? null;
};
